// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Montserrat', 'Montserrat Fallback'","fontStyle":"normal"},"className":"__className_4bc053","variable":"__variable_4bc053"};